import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
   const [settings, setSettings] = useState({ dateFormat: 'dd/MM/yyyy', timeFormat: 'HH:mm:ss' });

   const updateSetting = useCallback((key, value) => {
      setSettings((prevSettings) => ({
         ...prevSettings,
         [key]: value,
      }));
   }, []);

   return (
      <SettingsContext.Provider value={useMemo(() => ({ settings, updateSetting }), [settings, updateSetting])}>
         {children}
      </SettingsContext.Provider>
   );
};

export const useSettings = () => useContext(SettingsContext);
